import React, {useState} from 'react';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Divider, DialogActions, MenuItem, Card, Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import Grid from "@mui/material/Grid2";
import {useSnackbar} from "notistack";
import LoadingButton from "../../../../components/elements/LoadingButton";
import axios from "axios";
import {defaultVariables} from "../../../../../config";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import AppCardLoaderFields from "../../../../components/loaders/AppCardLoaderFields";
import RayaField from "../../../../components/elements/fields/RayaField";
import {HandCoins, RefreshCcw} from "lucide-react";
import SubTitle from "../../../../components/elements/SubTitle";
import {
    calcStockPrice,
    currencySymbol,
    price
} from "../../../../../config/values";
import UserChooser from "../../../../components/elements/fields/UserChooser";
import NumberField from "../../../../components/elements/fields/NumberField";
import {useIsSmall} from "../../../../../config/hooks/useWindowDimensions";

const AddProfitButton = ({ classes,reload,item_id }) => {
    const [open, setOpen] = useState(false);
    const navigation = useNavigate();
    const { t } = useTranslation();

    const initFields = {
        amount: '',
        title: '',
        stock_type: 'normal',
        type: 'all',
    };
    const [fields, setFields] = useState(initFields);
    const [errors, setErrors] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [user_id, setUserId] = useState(null);
    const isSmall = useIsSmall();

    const loginToken = localStorage.getItem('ACT');
    const handleChange = (e) => {
        let { name, value } = e.target;
        setFields((prevFields) => ({ ...prevFields, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };
    const handleField = (input,val) => {
        setFields((prevFields) => ({ ...prevFields, [input] : val }));
        setErrors((prevErrors) => ({ ...prevErrors, [input]: '' }));

    };
    const resetFields = () => {
        setFields(initFields);
    }
    const closeDialog = () => {
        setOpen(false);
        if(!item_id){
            setTimeout(() => {
                resetFields();
            }, 300);
        }

    }
    const handleValidation = async (callback) => {
        let formIsValid = true;
        let newErrors = {};
        if(fields.type === "specific_user"){
            if(!user_id){
                formIsValid = false;
                newErrors.user = t('emptyField');
            }
        }
        if(!fields.title){
            if(!user_id){
                formIsValid = false;
                newErrors.title = t('emptyField');
            }
        }
        if(!fields.amount){
            if(!user_id){
                formIsValid = false;
                newErrors.amount = t('emptyField');
            }
        }

        setErrors(newErrors);
        if (!formIsValid) setSubmitLoading(false);
        callback(formIsValid);
    };

    const handleRequest = async () => {

        const data = new FormData();
        data.append('title', fields.title);
        data.append('amount', fields.amount);
        data.append('stock_type', fields.stock_type);
        data.append('type', fields.type);
        if(!!user_id){
            data.append('user_id', user_id);
        }


        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/profits/assign`, data, config);
            reload();
            setSubmitLoading(false);
            closeDialog();
            enqueueSnackbar(t('detailsSet'), { variant: 'success' });

        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);
            if(error.response.status === 400){
                enqueueSnackbar(t('NoStockWithOptions'), { variant: 'warning' });
            }else{
                enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });
            }
        }
    };
    const handleInputChange = (fieldName, value) => {
        setFields((prevFields) => ({
            ...prevFields,
            [fieldName]: value,
        }));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) handleRequest();
        });
    };
    return (
        <>
            {
                isSmall ?
                    <IconButton
                        color="secondary"
                        onClick={() => setOpen(!open)}
                    >
                        <HandCoins/>
                    </IconButton>
                    :
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => setOpen(!open)}
                        startIcon={<HandCoins/>}
                    >
                        {t('assignProfit')}
                    </Button>
            }
            <Dialog
                fullWidth
                maxWidth={'sm'}
                open={open}
                onClose={() => closeDialog()}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">
                    {t('assignProfit')}
                    <IconButton aria-label="close" className={classes.dialogClose} onClick={() => closeDialog()}>
                        <CloseIcon/>
                    </IconButton>
                </DialogTitle>
                <Divider/>
                <DialogContent className="dialog-add-match">
                    <Grid container spacing={2}>
                        {
                            !!loading ?
                                <Grid item size={12}>
                                    <AppCardLoaderFields height={300}/>
                                </Grid>
                                    :
                                <>
                                    <Grid item size={{xs:12}}>
                                        <RayaField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            label={t('profit_type')}
                                            name="type"
                                            value={fields.type}
                                            onChange={handleChange}
                                            error={!!errors.type}
                                            helperText={errors.type}
                                            select
                                        >
                                            <MenuItem value="specific_user">{t('specific_user')}</MenuItem>
                                            <MenuItem value="two_months">{t('two_months')}</MenuItem>
                                            <MenuItem value="all_cleared">{t('all_cleared')}</MenuItem>
                                            <MenuItem value="all">{t('all')}</MenuItem>
                                        </RayaField>
                                    </Grid>
                                    {
                                        fields.type === "specific_user" &&
                                        <Grid item size={{xs:12}}>
                                            <UserChooser
                                                handleRes={(user) => !!user && setUserId(user.id)}
                                                default_id={user_id}
                                                error={errors['user']}
                                                stockholders
                                            />
                                        </Grid>
                                    }
                                    <Grid item size={{xs:12}}>
                                        <RayaField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            label={t('titleProfit')}
                                            name="title"
                                            value={fields.title}
                                            onChange={handleChange}
                                            error={!!errors.title}
                                            helperText={errors.title}
                                        />
                                    </Grid>
                                    <Grid item size={{xs:12,md:6}}>
                                        <RayaField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            label={t('stock_type')}
                                            name="stock_type"
                                            value={fields.stock_type}
                                            onChange={handleChange}
                                            error={!!errors.stock_type}
                                            helperText={errors.stock_type}
                                            select
                                        >
                                            <MenuItem value="normal">{t('normalStock')}</MenuItem>
                                            <MenuItem value="special">{t('specialStock')}</MenuItem>
                                        </RayaField>
                                    </Grid>
                                    <Grid item size={{xs:12,md:6}}>
                                        <NumberField
                                            fullWidth
                                            label={t('profitPrice')}
                                            variant="outlined"
                                            value={fields.amount}
                                            endAdornment={currencySymbol}
                                            decimals={2}
                                            min={0}
                                            onChange={(res) => handleInputChange('amount', res)}
                                            error={!!errors.amount}
                                            helperText={errors.amount}
                                        />
                                    </Grid>
                                    <Grid item size={12}>
                                        <Typography>
                                            {t('profitsCaution')}
                                        </Typography>
                                        <Typography>
                                            {t('profitsFirIncomplete')}
                                        </Typography>
                                    </Grid>
                                </>
                        }

                    </Grid>
                </DialogContent>
                <DialogActions style={{display:"flex",justifyContent:"center"}}>
                        <LoadingButton
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            loading={submitLoading}
                        >
                            {t('assignProfit')}
                        </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default withStyles(Styles)(AddProfitButton);
